export class UserGroupModel {

    constructor(public Id: number, public Name: string, public StartDate: Date, public SupervisorId: string) {
    }

    public IsSupervisor: boolean;
    public HasSupervisor: boolean;
    public UserId: string;
}
